
import LayoutContainer from '@/components/layout/Container'
import VButton from '~/components/ui/VButton.vue'
import Declension from '@/services/Declension'
import 'vue-slider-component/theme/default.css'

export default {
    components: {
        VButton,
        LayoutContainer
    },
    data() {
        return {
            sum: 500000,
            sumMarks: {
                '500000': '500 000',
                '15000000': '15 000 000',
            },
            showedVideoPreview: true,
            declension: Declension,
        }
    },
    head: {
        title: 'Ко-Фи — платформа коллективного финансирования для предпринимателей',
        meta: [
            { 
                hid: 'og:title',
                name: 'og:title',
                property: 'og:title',
                content: 'Ко-Фи — платформа коллективного финансирования для предпринимателей'
            },
            {
                hid: 'description',
                name: 'description',
                content: 'Быстро и легко привлекайте займы на развитие своего бизнеса. * Займы для ИП до 3 млн рублей, на срок до 1 года. Сбор средств от двух дней, выдача — мгновенно. Без залога и поручительства.',
            },
            { 
                hid: 'og:description',
                name: 'og:description',
                property: 'og:description',
                content: 'Быстро и легко привлекайте займы на развитие своего бизнеса. * Займы для ИП до 3 млн рублей, на срок до 1 года. Сбор средств от двух дней, выдача — мгновенно. Без залога и поручительства.'
            },
        ]
    },
    // mounted() {
    //     console.warn('convert', this.convert())
    // },
    computed: {
        calcItems() {
            return [
                {
                    title: '3 месяца',
                    desc: 'Минимальная переплата',
                    percent: 25,
                    months: 3
                },
                {
                    title: '6 месяцев',
                    desc: 'Для сезонных товаров',
                    percent: 28,
                    months: 6
                },
                {
                    title: '9 месяцев',
                    desc: 'На закуп у производителя',
                    percent: 32,
                    months: 9
                },
                {
                    title: '12 месяцев',
                    desc: 'Минимальный платеж',
                    percent: 35,
                    months: 12
                },
            ]
        }
    },
    methods: {
        calcSumPerMonth(months, percent) {
            const monthlyRate = percent / 100 / 12
            const numerator = monthlyRate * Math.pow(1 + monthlyRate, months)
            const denominator = Math.pow(1 + monthlyRate, months) - 1

            return this.sum * (numerator / denominator)
        },
        calcOverpayment(sumPerMonth, months) {
            return sumPerMonth * months - this.sum
        },
        handleRegister(role = null) {
            window.open(this.$config.AUTH, '_self');
        },
    }
}
